export const FLAGS = {};

export const SWITCHES = {
    ENABLE_DEALER_SELECTOR: 'enable-dealer-selector',
};
